import { createReducer } from '@reduxjs/toolkit';
import { GET_REWARD_RECEIVERS, INIT_REWARD_RECEIVERS, SET_UPDATE_REWARD } from '../actions/rewards';

type Reward = unknown;
type Receiver = unknown;

export type RewardState = {
  reward: Reward;
  receivers: Receiver[];
};

const initialState: RewardState = {
  reward: {},
  receivers: [],
};

const rewardReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(SET_UPDATE_REWARD, (state, action) => {
      return { ...state, reward: action.payload };
    })
    .addCase(INIT_REWARD_RECEIVERS, (state) => {
      return { ...state, receivers: [] };
    })
    .addCase(GET_REWARD_RECEIVERS, (state, action) => {
      return { ...state, receivers: action.payload };
    })
);

export default rewardReducer;
